import React from 'react';
import { Button } from '../../../components/base/Button';

export const CTASection: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-6xl font-bold text-gray-900 mb-4 leading-tight">
            Начните играть в лучших<br />мобильных казино онлайн сегодня
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            Эксклюзивные бонусы для новых игроков от Casino-Rus.Online
          </p>
          
          <Button variant="dark" size="lg" icon="ri-arrow-right-line">
            Выбрать казино
          </Button>
        </div>

        <div className="flex items-center justify-center gap-8 flex-wrap mt-16">
          <img
            src="https://public.readdy.ai/ai/img_res/5754738d0c88ace309e97b2aee3b24f2.jpg"
            alt="Winner"
            className="w-32 h-32 object-contain"
          />
          <img
            src="https://readdy.ai/api/search-image?query=stack%20of%20colorful%20casino%20chips%20and%20playing%20cards%2C%20gambling%20elements%2C%20clean%20cutout%20on%20white%20background%2C%20professional%20studio%20shot%2C%20photorealistic%20quality&width=200&height=200&seq=35&orientation=squarish"
            alt="Casino Chips"
            className="w-32 h-32 object-contain"
          />
          <img
            src="https://readdy.ai/api/search-image?query=golden%20jackpot%20slot%20machine%20with%20lucky%20seven%20symbols%2C%20winning%20concept%2C%20clean%20cutout%20on%20white%20background%2C%20premium%203d%20render%2C%20high%20quality&width=200&height=200&seq=36&orientation=squarish"
            alt="Jackpot"
            className="w-32 h-32 object-contain"
          />
          <img
            src="https://readdy.ai/api/search-image?query=smartphone%20displaying%20casino%20app%20with%20bonus%20notification%2C%20mobile%20gaming%2C%20clean%20cutout%20on%20white%20background%2C%20modern%20product%20photography%2C%20realistic%20quality&width=200&height=200&seq=37&orientation=squarish"
            alt="Mobile Casino"
            className="w-32 h-32 object-contain"
          />
        </div>
      </div>
    </section>
  );
};